// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.shimmer-parent {
  overflow: auto;
}

.trend-product-section .header {
  padding: 2% 10%;
}
.trend-product-section .header .header-text {
  font-weight: bolder;
  font-size: 50px;
}
.trend-product-section .btn-circle {
  transition: transform 0.5s ease-in-out;
  animation: bounce 1.5s infinite;
  background: rgba(174, 165, 180, 0.384);
  border-radius: 16px;
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(5.5px);
  -webkit-backdrop-filter: blur(5.5px);
  padding: 15px 20px;
}
.trend-product-section .trend-product-parent-container {
  margin-top: -3%;
  margin-bottom: 5%;
  overflow-x: auto;
  overflow-y: hidden !important;
  padding-left: 10%;
  width: 100vw;
}
.trend-product-section .trend-product-parent-container .trend-product-col {
  width: 350px !important;
}
.trend-product-section .trend-product-parent-container .trend-product-showcard {
  height: 410px;
}
.trend-product-section .trend-product-parent-container .trend-product-card {
  height: 410px;
  border: 1px solid rgba(192, 192, 192, 0.281);
  border-radius: 40px;
}
.trend-product-section .trend-product-parent-container .trend-product-image {
  width: 230px;
  height: 200px;
  object-fit: contain;
}
.trend-product-section .trend-product-parent-container .trend-product-image-showcase {
  width: 320px;
  height: 300px;
  object-fit: cover;
  margin-left: -10%;
}
.trend-product-section .trend-product-parent-container .floating-btn-area {
  position: absolute;
  bottom: 0;
  right: 0;
  padding-bottom: 15px;
}
.trend-product-section .trend-product-parent-container .trend-product-title {
  font-size: 13px;
}
.trend-product-section .trend-product-parent-container .trend-product-body {
  font-size: 12px;
}
.trend-product-section .trend-product-parent-container .trend-product-amount {
  font-size: 13px;
  font-weight: bolder;
  margin-top: -5%;
}
.trend-product-section .trend-product-parent-container .bold-text-name {
  line-height: 45px;
}

@media only screen and (max-width: 992px) {
  .header {
    padding: 2% 10%;
    margin-top: -5% !important;
  }
}
@media only screen and (max-width: 767px) {
  .header {
    padding: 2% 10%;
    margin-top: 5% !important;
  }
  .header-text {
    font-size: 40px !important;
    text-align: center;
  }
}
@media only screen and (max-width: 599px) {
  .header-text {
    font-size: 30px !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/presentation/main/home/components/trend-products/trendproduct.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;AACF;;AAGE;EACE,eAAA;AAAJ;AACI;EACE,mBAAA;EACA,eAAA;AACN;AAGE;EACE,sCAAA;EACA,+BAAA;EACA,sCAAA;EACA,mBAAA;EACA,yCAAA;EACA,4BAAA;EACA,oCAAA;EACA,kBAAA;AADJ;AAIE;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,6BAAA;EACA,iBAAA;EACA,YAAA;AAFJ;AAII;EACE,uBAAA;AAFN;AAKI;EACE,aAAA;AAHN;AAKI;EACE,aAAA;EACA,4CAAA;EACA,mBAAA;AAHN;AAMI;EACE,YAAA;EACA,aAAA;EACA,mBAAA;AAJN;AAOI;EACE,YAAA;EACA,aAAA;EACA,iBAAA;EACA,iBAAA;AALN;AAQI;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,oBAAA;AANN;AASI;EACE,eAAA;AAPN;AASI;EACE,eAAA;AAPN;AASI;EACE,eAAA;EACA,mBAAA;EACA,eAAA;AAPN;AASI;EACE,iBAAA;AAPN;;AAYA;EACE;IACE,eAAA;IACA,0BAAA;EATF;AACF;AAYA;EACE;IACE,eAAA;IACA,yBAAA;EAVF;EAaA;IACE,0BAAA;IACA,kBAAA;EAXF;AACF;AAcA;EACE;IACE,0BAAA;EAZF;AACF","sourcesContent":[".shimmer-parent {\n  overflow: auto;\n}\n\n.trend-product-section {\n  .header {\n    padding: 2% 10%;\n    .header-text {\n      font-weight: bolder;\n      font-size: 50px;\n    }\n  }\n\n  .btn-circle {\n    transition: transform 0.5s ease-in-out;\n    animation: bounce 1.5s infinite;\n    background: rgba(174, 165, 180, 0.384);\n    border-radius: 16px;\n    box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);\n    backdrop-filter: blur(5.5px);\n    -webkit-backdrop-filter: blur(5.5px);\n    padding:15px 20px;\n  }\n\n  .trend-product-parent-container {\n    margin-top: -3%;\n    margin-bottom: 5%;\n    overflow-x: auto;\n    overflow-y: hidden !important;\n    padding-left: 10%;\n    width: 100vw;\n\n    .trend-product-col {\n      width: 350px !important;\n    }\n\n    .trend-product-showcard {\n      height: 410px;\n    }\n    .trend-product-card {\n      height: 410px;\n      border: 1px solid rgba(192, 192, 192, 0.281);\n      border-radius: 40px;\n    }\n\n    .trend-product-image {\n      width: 230px;\n      height: 200px;\n      object-fit: contain;\n    }\n\n    .trend-product-image-showcase {\n      width: 320px;\n      height: 300px;\n      object-fit: cover;\n      margin-left: -10%;\n    }\n\n    .floating-btn-area {\n      position: absolute;\n      bottom: 0;\n      right: 0;\n      padding-bottom: 15px;\n    }\n\n    .trend-product-title {\n      font-size: 13px;\n    }\n    .trend-product-body {\n      font-size: 12px;\n    }\n    .trend-product-amount {\n      font-size: 13px;\n      font-weight: bolder;\n      margin-top: -5%;\n    }\n    .bold-text-name {\n      line-height: 45px;\n    }\n  }\n}\n\n@media only screen and (max-width: 992px) {\n  .header {\n    padding: 2% 10%;\n    margin-top: -5% !important;\n  }\n}\n\n@media only screen and (max-width: 767px) {\n  .header {\n    padding: 2% 10%;\n    margin-top: 5% !important;\n  }\n\n  .header-text {\n    font-size: 40px !important;\n    text-align: center;\n  }\n}\n\n@media only screen and (max-width: 599px) {\n  .header-text {\n    font-size: 30px !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
